import "./Projects.css";
import planit from "../../assets/planit.png";
// import qualitea from "../../assets/qualitea.png";
import genie from "../../assets/genie.png";
import kiddyup from "../../assets/kiddyup.png";
import traditrakr from "../../assets/traditrakr.png";
import javascript from "../../assets/javascript.svg";
import nodejs from "../../assets/nodejs.svg";
import react from "../../assets/react.svg";
import css from "../../assets/css.svg";
import express from "../../assets/mongodb.svg";
import mongodb from "../../assets/express.svg";
import jest from "../../assets/jest.svg";
import html from "../../assets/html.svg";
import mantine from "../../assets/mantine.svg";
import recoil from "../../assets/recoil.svg";

import {
    useTheme,
    Box,
    Image,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    IconButton,
    UnorderedList,
    Text,
    ListItem,
    HStack,
} from "@chakra-ui/react";
import { IoOpenOutline } from "react-icons/io5";

const Projects = () => {
    const theme = useTheme();
    const {
        isOpen: isFirstModalOpen,
        onOpen: onFirstModalOpen,
        onClose: onFirstModalClose,
    } = useDisclosure();
    const {
        isOpen: isSecondModalOpen,
        onOpen: onSecondModalOpen,
        onClose: onSecondModalClose,
    } = useDisclosure();
    const {
        isOpen: isThirdModalOpen,
        onOpen: onThirdModalOpen,
        onClose: onThirdModalClose,
    } = useDisclosure();
    const {
        isOpen: isFourthModalOpen,
        onOpen: onFourthModalOpen,
        onClose: onFourthModalClose,
    } = useDisclosure();
    return (
        <div
            className="projects"
            id="projects"
            style={{
                backgroundColor: theme.colors.secondary,
                color: theme.colors.primary,
            }}
        >
            <h1 className="sectionHeading">Projects</h1>
            <Box className="projectsContainer">
                <Box
                    className="projectBox"
                    p={5}
                    shadow="md"
                    borderWidth="1px"
                    backgroundColor="white"
                >
                    <h2 className="projectHeading" mb={3} mt={2} align="center">
                        Planit Events Finder
                    </h2>
                    <Image
                        src={planit}
                        alt="planit project"
                        className="projectImage"
                        objectFit="cover"
                    />
                    <HStack className="skillIconContainer">
                        <Image
                            src={javascript}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={react}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={css}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={jest}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <a
                            href="https://planitevents.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        >
                            <IconButton
                                style={{
                                    color: theme.colors.primary,
                                    backgroundColor: "white",
                                }}
                                size="lg"
                                aria-label="open project"
                                icon={<IoOpenOutline />}
                            ></IconButton>
                        </a>
                    </HStack>

                    <Button
                        onClick={onFirstModalOpen}
                        className="projectButton"
                        style={{
                            color: "white",
                            backgroundColor: theme.colors.tertiary,
                        }}
                    >
                        More details
                    </Button>
                </Box>
                <Box
                    p={5}
                    shadow="md"
                    borderWidth="1px"
                    backgroundColor="white"
                    className="projectBox"
                >
                    <h2 className="projectHeading" mb={3} mt={2} align="center">
                        TradiTrakr Job Tracking
                    </h2>
                    <Image
                        src={traditrakr}
                        alt="traditrakr project"
                        className="projectImage"
                        objectFit="cover"
                    />
                    <HStack className="skillIconContainer">
                        <Image
                            src={react}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={mantine}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={recoil}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <a
                            href="https://traditrakr.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        >
                            <IconButton
                                style={{
                                    color: theme.colors.primary,
                                    backgroundColor: "white",
                                }}
                                size="lg"
                                aria-label="open project"
                                icon={<IoOpenOutline />}
                            ></IconButton>
                        </a>
                    </HStack>
                    <Button
                        onClick={onSecondModalOpen}
                        className="projectButton"
                        style={{
                            color: "white",
                            backgroundColor: theme.colors.tertiary,
                        }}
                    >
                        More details
                    </Button>
                </Box>
                <Box
                    p={5}
                    shadow="md"
                    borderWidth="1px"
                    backgroundColor="white"
                    className="projectBox"
                >
                    <h2 className="projectHeading" mb={3} mt={2} align="center">
                        Drink Genie Chatbot
                    </h2>
                    <Image
                        src={genie}
                        alt="genie project"
                        className="projectImage"
                        objectFit="cover"
                    />
                    <HStack className="skillIconContainer">
                        <Image
                            src={javascript}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={html}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={css}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={jest}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <a
                            href="https://drinkgenie.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <IconButton
                                style={{
                                    color: theme.colors.primary,
                                    backgroundColor: "white",
                                }}
                                size="lg"
                                aria-label="open project"
                                icon={<IoOpenOutline />}
                                className="openProjectIcon"
                            />
                        </a>
                    </HStack>
                    <Button
                        onClick={onThirdModalOpen}
                        className="projectButton"
                        style={{
                            color: "white",
                            backgroundColor: theme.colors.tertiary,
                        }}
                    >
                        More details
                    </Button>
                </Box>
                <Box
                    p={5}
                    shadow="md"
                    borderWidth="1px"
                    backgroundColor="white"
                    className="projectBox"
                >
                    <h2 className="projectHeading" mb={3} mt={2} align="center">
                        Kiddyup Parent Meetup
                    </h2>
                    <Image
                        src={kiddyup}
                        alt="kiddyup project"
                        className="projectImage"
                        objectFit="cover"
                    />
                    <HStack className="skillIconContainer">
                        <Image
                            src={react}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={mantine}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={nodejs}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={mongodb}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={express}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <a
                            href="https://kiddy-up.onrender.com"
                            target="_blank"
                            rel="noreferrer"
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        >
                            <IconButton
                                style={{
                                    color: theme.colors.primary,
                                    backgroundColor: "white",
                                }}
                                size="lg"
                                aria-label="open project"
                                icon={<IoOpenOutline />}
                            ></IconButton>
                        </a>
                    </HStack>
                    <Button
                        onClick={onFourthModalOpen}
                        className="projectButton"
                        style={{
                            color: "white",
                            backgroundColor: theme.colors.tertiary,
                        }}
                    >
                        More details
                    </Button>
                </Box>
                {/* <Box
                    p={5}
                    shadow="md"
                    borderWidth="1px"
                    backgroundColor="white"
                    className="projectBox"
                >
                    <h2 className="projectHeading" mb={3} mt={2} align="center">
                        Qualitea Teashop
                    </h2>
                    <Image
                        src={qualitea}
                        alt="qualitea project"
                        className="projectImage"
                        objectFit="cover"
                    />
                    <HStack className="skillIconContainer">
                        <Image
                            src={javascript}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={react}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <Image
                            src={css}
                            w={[7, 7, 7, 7, 8, 12]}
                            h={[7, 7, 7, 7, 8, 12]}
                            m={1}
                        />
                        <a
                            href="https://qualitea.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <IconButton
                                style={{
                                    color: theme.colors.primary,
                                    backgroundColor: "white",
                                }}
                                size="lg"
                                aria-label="open project"
                                icon={<IoOpenOutline />}
                                className="openProjectIcon"
                            />
                        </a>
                    </HStack>
                    <Button
                        className="projectButton"
                        onClick={onFourthModalOpen}
                        style={{
                            color: "white",
                            backgroundColor: theme.colors.tertiary,
                        }}
                    >
                        More details
                    </Button>
                </Box> */}
            </Box>
            <Modal isOpen={isFirstModalOpen} onClose={onFirstModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Planit Events Finder</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            An online event searching database allowing users to
                            browse and save events.
                        </Text>
                        <UnorderedList>
                            <ListItem>React framework with Chakra</ListItem>
                            <ListItem>Fetches from Ticketmaster API</ListItem>
                            <ListItem>
                                Uses Luxon for date formatting and Geohash for
                                location
                            </ListItem>
                            <ListItem>Includes pagination</ListItem>
                            <ListItem>Uses local storage</ListItem>
                            <ListItem>
                                Mobile, tablet and desktop responsive - CSS Grid
                                and Media queries
                            </ListItem>
                            <ListItem>Jest for automated unit testing</ListItem>
                        </UnorderedList>
                        <HStack className="skillIconContainer">
                            <Image src={javascript} w={7} h={7} m={1} />
                            <Image src={react} w={7} h={7} m={1} />
                            <Image src={css} w={7} h={7} m={1} />
                            <Image src={jest} w={7} h={7} m={1} />
                        </HStack>
                        <HStack mt="1rem" mb="1rem">
                            <a
                                href="https://github.com/annafran/planit-event-planner"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View on GitHub
                                </Button>
                            </a>
                            <a
                                href="https://planitevents.netlify.app/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View deployed project
                                </Button>
                            </a>
                        </HStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal isOpen={isSecondModalOpen} onClose={onSecondModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>TradiTrakr Job Tracking App</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            An app for tradies to create, view and update their
                            jobs.
                        </Text>
                        <UnorderedList>
                            <ListItem>React framework</ListItem>
                            <ListItem>State management with recoil</ListItem>

                            <ListItem>
                                Local storage to save jobs using Recoil Persist
                            </ListItem>
                            <ListItem>
                                Uses Mantine library and form state.
                            </ListItem>
                        </UnorderedList>
                        <HStack className="skillIconContainer">
                            <Image src={javascript} w={7} h={7} m={1} />
                            <Image src={react} w={7} h={7} m={1} />
                            <Image src={mantine} w={7} h={7} m={1} />
                            <Image src={recoil} w={7} h={7} m={1} />
                        </HStack>
                        <HStack mt="1rem" mb="1rem">
                            <a
                                href="https://github.com/annafran/traditrakr"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View on GitHub
                                </Button>
                            </a>
                            <a
                                href="https://traditrakr.netlify.app/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View deployed project
                                </Button>
                            </a>
                        </HStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal isOpen={isThirdModalOpen} onClose={onThirdModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Drink Genie Chatbot</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            The chat-bot asks the user questions to reach a
                            decision on a suitable drink.
                        </Text>
                        <UnorderedList>
                            <ListItem>Javascript conditionals</ListItem>
                            <ListItem>Responsive Design - CSS Grid</ListItem>
                        </UnorderedList>
                        <HStack className="skillIconContainer">
                            <Image src={javascript} w={7} h={7} m={1} />
                            <Image src={html} w={7} h={7} m={1} />
                            <Image src={css} w={7} h={7} m={1} />
                            <Image src={jest} w={7} h={7} m={1} />
                        </HStack>
                        <HStack mt="1rem" mb="1rem">
                            <a
                                href="https://drinkgenie.netlify.app/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View deployed site
                                </Button>
                            </a>
                        </HStack>
                        <Text
                            mt={1}
                            mb={1}
                            fontSize="0.8rem"
                            fontStyle="italic"
                        >
                            *This was a project for Developers Institute. Some
                            boilerplate was provided for the base of the React
                            app.
                        </Text>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal isOpen={isFourthModalOpen} onClose={onFourthModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Kiddyup Parent Meetup</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            An online platform for parents to connect with other
                            parents.
                        </Text>
                        <UnorderedList>
                            <ListItem>React framework</ListItem>
                            <ListItem>
                                Connects to Google Maps API to display profiles
                                by location
                            </ListItem>
                            <ListItem>
                                Uses Mantine library with use-form component to
                                manage form state.
                            </ListItem>
                            <ListItem>
                                Fetches random user data from randomuser.me API
                            </ListItem>
                            <ListItem>
                                Uses NodeJS and Express to perform CRUD
                            </ListItem>
                            <ListItem>
                                Built with Docker compose to run MongoDB image
                            </ListItem>
                            <ListItem>
                                Mobile, tablet and desktop responsive - CSS Grid
                                and Media queries
                            </ListItem>
                        </UnorderedList>
                        <HStack className="skillIconContainer">
                            <Image src={javascript} w={7} h={7} m={1} />
                            <Image src={react} w={7} h={7} m={1} />
                            <Image src={mantine} w={7} h={7} m={1} />
                            <Image src={nodejs} w={7} h={7} m={1} />
                            <Image src={express} w={7} h={7} m={1} />
                            <Image src={mongodb} w={7} h={7} m={1} />
                        </HStack>
                        <HStack mt="1rem" mb="1rem">
                            <a
                                href="https://github.com/annafran/kiddyup"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View on GitHub
                                </Button>
                            </a>
                            <a
                                href="https://kiddy-up.onrender.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View deployed project
                                </Button>
                            </a>
                        </HStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* <Modal isOpen={isFourthModalOpen} onClose={onFourthModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Qualitea Online Teashop</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            An online teashop allowing customers to search for
                            products and purchase online via Stripe.
                        </Text>
                        <UnorderedList>
                            <ListItem>React framework</ListItem>
                            <ListItem>
                                Filters, sorts and search function
                            </ListItem>
                            <ListItem>Server-less platform Begin.com</ListItem>
                            <ListItem>Responsive design - CSS Grid</ListItem>
                            <ListItem>Fetches from Stripe API</ListItem>
                        </UnorderedList>
                        <HStack className="skillIconContainer">
                            <Image src={javascript} w={7} h={7} m={1} />
                            <Image src={react} w={7} h={7} m={1} />
                            <Image src={css} w={7} h={7} m={1} />
                        </HStack>
                        <HStack mt="1rem" mb="1rem">
                            <a
                                href="https://qualitea.netlify.app/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button
                                    style={{
                                        color: "white",
                                        backgroundColor: theme.colors.tertiary,
                                    }}
                                    ml={3}
                                >
                                    View deployed site
                                </Button>
                            </a>
                        </HStack>
                        <Text
                            mt={1}
                            mb={1}
                            fontSize="0.8rem"
                            fontStyle="italic"
                        >
                            *This was a project for Developers Institute. Some
                            boilerplate was provided for the base of the React
                            app.
                        </Text>
                    </ModalBody>
                </ModalContent>
            </Modal> */}
        </div>
    );
};

export default Projects;
